import { useState, useCallback } from 'react';
import { MaintenanceState } from 'types/Maintenance';

// Klucz localStorage - zawiera datę dla której użytkownik zamknął okno
const MAINTENANCE_DONT_SHOW_KEY = 'maintenanceDontShow';

export const useMaintenance = () => {
	const [state, setState] = useState<MaintenanceState>(() => {
		const envDate = process.env.REACT_APP_MAINTENANCE_DATE;
		let scheduledDate: Date | null = null;
		let showNotification = false;

		if (envDate) {
			try {
				const parsedDate = new Date(envDate);
				if (!Number.isNaN(parsedDate.getTime()) && parsedDate > new Date()) {
					scheduledDate = parsedDate;
					const dismissedForDate = localStorage.getItem(MAINTENANCE_DONT_SHOW_KEY);
					showNotification =
						!dismissedForDate || dismissedForDate === 'false' || dismissedForDate !== envDate;
				}
			} catch (error) {
				console.error('Invalid maintenance date in env:', envDate);
			}
		}

		return {
			scheduledDate,
			isMaintenanceActive: false,
			showNotification,
		};
	});

	const dismissNotification = useCallback(() => {
		setState((prev) => ({
			...prev,
			showNotification: false,
		}));
	}, []);

	const setDontShowAgain = useCallback((value: boolean) => {
		const envDate = process.env.REACT_APP_MAINTENANCE_DATE;
		if (value && envDate) {
			localStorage.setItem(MAINTENANCE_DONT_SHOW_KEY, envDate);
		} else {
			localStorage.setItem(MAINTENANCE_DONT_SHOW_KEY, 'false');
		}
	}, []);

	const getDontShowAgain = useCallback((): boolean => {
		const envDate = process.env.REACT_APP_MAINTENANCE_DATE;
		if (!envDate) return false;
		const dismissedForDate = localStorage.getItem(MAINTENANCE_DONT_SHOW_KEY);
		return dismissedForDate === envDate;
	}, []);

	return {
		...state,
		dismissNotification,
		setDontShowAgain,
		getDontShowAgain,
	};
};
